import React, { useState, useEffect } from 'react';
import { useAPI } from '../../ApiCalls/useAPI';
import { Card, Table, Tabs, Tab } from 'tabler-react';
import MoonLoader from 'react-spinners/MoonLoader';
import RemoveLastDirectoryPartOf from '../goBackButton';

export default function Results() {
    const [data, setData] = useState([]);
    const { getResults } = useAPI();
    useEffect(() => {
        getResults()
            .then((response) => {
                console.log(response, 'results');
                setData(response);
            })
            .catch((error) => console.error(error));
    }, []);
    const override = `
        display: block;
        margin: 10% auto;
        border-color: red;
    `;
    if (data.length === 0) {
        return (
            <div>
                <h1 className="mt-4" style={{ textAlign: 'center' }}>
                    Waiting for data ...
                </h1>
                <MoonLoader
                    color={'green'}
                    isLoading={true}
                    css={override}
                    size={60}
                />
            </div>
        );
    }
    return (
        <div className="container">
            {/* Back Button */}
             <div
                    className="m-2 mt-4"
                    style={{ fontSize: '20px', display: 'flex' }}
                >
                    <div className="mr-4">
                        <a
                            href={RemoveLastDirectoryPartOf(
                                window.location.href
                            )}
                            style={{ textDecoration: 'none' }}
                        >
                            <i className="fe fe-arrow-left" />
                        </a>
                    </div>
                    <div>Results</div>
                </div>
                {/* Actual data in the page */}
            <SecondTab results={data.results}/>
        </div>
    );
}

const SecondTab = ({ results }) => {
   
    return (
        <div className="SecondTab">
            <div className="">
                {results.map((data, index) => (
                    <Card key={index} title={data.label}>
                        <Table>
                            <Table.Header>
                                <Table.ColHeader>Date</Table.ColHeader>
                                <Table.ColHeader>Subject</Table.ColHeader>
                                <Table.ColHeader>Marks</Table.ColHeader>
                                {/* Add additional headers as needed */}
                            </Table.Header>

                            <Table.Body>
                                {data.subjects.length > 0 ? (
                                    data.subjects.map((subject, subIndex) => (
                                        <Table.Row key={subIndex}>
                                            <Table.Col>{subject.dateofconduct}</Table.Col>
                                            <Table.Col>{subject.subject}</Table.Col>
                                            <Table.Col>{subject.score}</Table.Col>
                                            {/* Add additional columns as needed */}
                                        </Table.Row>
                                    ))
                                ) : (
                                    <Table.Row>
                                        <Table.Col colSpan={5} className="text-center">
                                            NO DATA FOUND
                                        </Table.Col>
                                    </Table.Row>
                                )}
                                {data.subjects.total && (
                                    <Table.Row key="total">
                                        <Table.Col></Table.Col>
                                        <Table.Col>Total</Table.Col>
                                        <Table.Col>{data.subjects.score}</Table.Col>
                                        {/* Add additional columns if needed */}
                                    </Table.Row>
                                )}
                            </Table.Body>
                        </Table>
                    </Card>
                ))}
            </div>
        </div>
    );
};

